module.exports = {
	baseUrl: "",
	// fileUrl:"http://222.27.186.88",
	// baseUrl:"http://10.0.7.202:8282/api/",
	fileUrl: "http://10.0.7.202:8282",
	// baseUrl:"http://192.168.31.25:8181/api/",
	// fileUrl:"http://192.168.31.25:8181",
	timeout: 15 * 1000,
	homeLink: ['', '', '']
}